import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import TextField from "@mui/material/TextField";

export const StyledSearch = styled(TextField)({
  width: "100%",
  "& input": {
    padding: "1rem 1.2rem",
  },
});

export const StyledList = styled(List)({
  maxHeight: "80vh",
  overflowY: "auto",
  "&:focus": {
    outline: "none",
  },
});
